<template>
<div>
<v-form
   ref="form"
   v-model="valid"
   @submit.prevent="submit"
>
  <v-container fluid>
    <v-row justify="space-between" style="height: 102px;">
      <v-col cols="4" class="text-left">

        <template v-if="is_new">
            <v-btn color="" class="mr-5" to="/stafflist">
                戻る</v-btn>
            <v-btn type="submit" color="mygreen" class="white--text">
                登録</v-btn>
        </template>

        <template v-else>
            <v-btn color="" class="mr-5" to="/stafflist">
                戻る</v-btn>
            <v-btn type="submit" color="mygreen" class="white--text mr-5">
                更新</v-btn>
            <DialogStaffDelete v-if="is_admin" @delete-item="deleteItemConfirm"></DialogStaffDelete>
        </template>

      </v-col>
    </v-row>
  </v-container>

  <v-card class="pa-4 pb-10 mycard">
    <v-container fluid class="myform">

        <v-row>
            <v-col cols="3" class="text-left">
                <h3 class="">{{ title }}</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>ID</div>
            </v-col>
            <v-col cols="1" align-self="center"> </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field class="gray" readonly label="" v-model="data.staff_str_id" outlined>{{data.staff_str_id}}</v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>スタッフ名(漢字)</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field v-model="data.sei" label="姓" outlined :rules="[v => !!v || '必須項目です.']"></v-text-field>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field v-model="data.mei" label="名" outlined :rules="[v => !!v || '必須項目です.']"></v-text-field>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>スタッフ名(カナ)</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field
                v-model="data.sei_kana"
                label="セイ"
                :rules="[v => !!v || '必須項目です.']"
                outlined></v-text-field>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field
                v-model="data.mei_kana"
                label="メイ"
                :rules="[v => !!v || '必須項目です.']"
                outlined></v-text-field>
            </v-col>
        </v-row>




        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>性別</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="6" align-self="end" class="pt-8">
                <v-radio-group v-model="data.sex" row mandatory class="d-flex align-center mb-4">
                    <v-radio color="#8CC11E" label="男性" value="M"></v-radio>
                    <v-radio color="#8CC11E" label="女性" value="F"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>生年月日</div>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="8" align-self="end" class="pt-11">
                <!-- 日付選択 -->
                <v-col cols="3" class="pl-0">
                    <v-menu
                        v-model="menu_birthday"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            v-model="data.birthday"
                            outlined
                            v-bind="attrs"
                            v-on="on"></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="birthday"
                            @input="menu_birthday = false"
                            color="mygreen"
                            locale="jp-ja"
                            :no-title="true"
                            :day-format="date => new Date(date).getDate()"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
            </v-col>
        </v-row>


        <!-- 住所 -->
        <v-row class="mt-10 mb-0">
            <v-col cols="2" class="text-left" align-self="center">
                <div>住所</div>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="8" align-self="center" class="text-left">
                    <div>
                    <span style="display: inline-block; margin-top: -23px; margin-right:10px; font-size:20px; vertical-align:middle;">〒</span>
                    <v-text-field 
                        v-model="data.post1"
                        @blur="fetchAddress"
                        :rules="rules_post1"
                        outlined
                        class="mypost"></v-text-field>
                    <span style="display: inline-block; margin-top: -23px; margin-right:10px;margin-left:10px; vertical-align: middle;">─</span>
                    <v-text-field 
                        v-model="data.post2"
                        @blur="fetchAddress"
                        :rules="rules_post2"
                        outlined
                        class="mypost"></v-text-field>
                        </div>
            </v-col>
        </v-row>
        <v-row style="margin-top: -24px;">
            <v-col cols="2" class="text-left" align-self="center"> </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="4" align-self="end" class="pt-4">
                <v-select v-model="data.prefecture" :items="pref" outlined placeholder="未選択" ></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="2" class="text-left" align-self="center"> </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="4" align-self="end" class="pt-2">
                <v-text-field v-model="data.city" label="市区町村名" outlined></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="2" class="text-left" align-self="center"> </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="4" align-self="end" class="pt-2">
                <v-text-field v-model="data.address" label="番地・ビル名" outlined></v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>固定電話番号</div>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="4" align-self="end" class="pt-11">
                <v-text-field v-model="data.tel" label="固定電話番号" outlined @blur="validphone('tel', tel)"></v-text-field>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>携帯電話番号</div>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="4" align-self="end" class="pt-11">
                <v-text-field v-model="data.phone" label="携帯電話番号" outlined @blur="validphone('phone', phone)"></v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>メールアドレス</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="4" align-self="end" class="pt-11">
                <v-text-field v-model="data.mail" label="メールアドレス" outlined  :rules="[v => !!v || '必須項目です.']"></v-text-field>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>パスワード</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="4" align-self="end" class="pt-11">
                <v-text-field v-model="data.password" label="パスワード" outlined
                :type="show_password ? 'text' : 'password'"
                :rules="[v => !!v || '必須項目です.', v => v.length>=8 || '8文字以上にしてください.']"
                @click:append = "show_password = ! show_password"
                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"></v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>職種</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="6" align-self="end" class="pt-11">
                <v-row>
                <v-col cols="3" align-self="center">
                    <v-select v-model="data.job" :items="jobs" :rules="[v => !!v || '必須項目です.']" outlined placeholder="未選択"></v-select>
                </v-col>

                <v-col cols="1" align-self="center" style="position: relative" v-if="!is_color_picker">
                    <div @click.stop="show_color_picker" class="v-color-picker__color" style="position: relative; top:-16px;width:30px;height:30px;min-height:30px;"><div :style="{'background': data.color_hex || data.color}"></div></div>
                </v-col>
                <v-col cols="9" style="position:relative;" v-if="is_color_picker">
                    <v-color-picker
                        class="color_picker"
                        style="position:absolute;bottom:0;"
                        v-model="data.color"
                        @update:color="onColorSelected"
                        :swatches="swatches"
                        hide-canvas
                        hide-inputs
                        hide-sliders
                        show-swatches></v-color-picker>
                </v-col>
                </v-row>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>権限</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="4" align-self="end" class="pt-11">
                <v-select v-model="data.auth" :items="auths" outlined placeholder="未選択"  :rules="[v => !!v || '必須項目です.']"></v-select>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>入社年月日</div>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="6" align-self="end" class="pt-11">
                <!-- 日付選択 -->
                <v-col cols="4" class="pl-0">
                    <v-menu
                        v-model="menu_hire_date"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            v-model="data.hire_date"
                            outlined
                            v-bind="attrs"
                            v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="data.hire_date" @input="menu_hire_date = false"
                            color="mygreen"
                            :no-title="true"
                            locale="jp-ja"
                            :day-format="date => new Date(date).getDate()"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
            </v-col>
        </v-row>



        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>退職年月日</div>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="6" align-self="end" class="pt-11">
                <!-- 日付選択 -->
                <v-col cols="4" class="pl-0">
                    <v-menu
                        v-model="menu_retirement_date"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            v-model="data.retirement_date"
                            outlined
                            v-bind="attrs"
                            v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="data.retirement_date" @input="menu_retirement_date = false"
                            color="mygreen"
                            :no-title="true"
                            locale="jp-ja"
                            :day-format="date => new Date(date).getDate()"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>時給</div>
            </v-col>
            <v-col cols="1" align-self="center"> </v-col>
            <v-col cols="4" align-self="end" class="pt-11">
                <v-text-field v-model="data.jikyu" label="" outlined></v-text-field>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>交通費</div>
            </v-col>
            <v-col cols="1" align-self="center"> </v-col>
            <v-col cols="4" align-self="end" class="pt-11">
                <v-text-field v-model="data.koutuhi" label="" outlined></v-text-field>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>在籍状況</div>
            </v-col>
            <v-col cols="1" align-self="center"> </v-col>
            <v-col cols="6" align-self="end" class="pt-8">
                <v-radio-group v-model="data.status" row mandatory class="d-flex align-center mb-4">
                    <v-radio color="#8CC11E" label="在籍中" value="在籍中"></v-radio>
                    <v-radio color="#8CC11E" label="休職中" value="休職中"></v-radio>
                    <v-radio color="#8CC11E" label="退職" value="退職"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>週の契約労働日数</div>
            </v-col>
            <v-col cols="1" align-self="center"> </v-col>
            <v-col cols="4" align-self="end" class="pt-11">
                <v-select v-model="data.shuu_work" :items="[1,2,3,4,5,6,7]" outlined placeholder="未選択" ></v-select>
            </v-col>
        </v-row>

        <v-row class="pt-11">
            <v-col cols="2" class="text-left">
                <div class="text-left mb-5">基本シフト時間</div>
            </v-col>
            <v-col cols="1" align-self="center"> </v-col>
            <v-col cols="4"  class="text-center" style="padding-right: 22px;"> 午前 </v-col>
            <v-col cols="4"  class="text-center" style="padding-right: 22px;"> 午後 </v-col>
        </v-row>


        <v-row v-for="(v) in data.eigyoubi" :key="v.id">
            <v-col cols="2"  class="text-left">
                {{v.dayofweek}}曜日
            </v-col>
            <v-col cols="1" align-self="center"> </v-col>
            <v-col cols="4" class="text-left d-flex flex-nowrap" align-self="start">
                    <v-select dense
                        append-icon="mdi-clock-time-four-outline"
                        menu-props="auto"
                        :items="first_start"
                        v-model="v.first_start"
                        outlined
                        placeholder="選択してください"
                        style="max-width: 40%;"
                    ></v-select>

                    <div style="font-weight: bold;text-align:center;min-width:10%;line-height: 2.2em; margin: 6px 10px;">～</div>

                    <v-select dense
                        append-icon="mdi-clock-time-four-outline"
                        menu-props="auto"
                        :items="first_end"
                        v-model="v.first_end"
                        outlined
                        placeholder="選択してください"
                        style="max-width: 40%;"
                    ></v-select>
            </v-col>

            <v-col cols="4" class="text-left d-flex flex-nowrap" align-self="start">

                    <v-select dense
                        append-icon="mdi-clock-time-four-outline"
                        menu-props="auto"
                        :items="second_start"
                        v-model="v.second_start"
                        outlined
                        placeholder="選択してください"
                        style="max-width: 40%;"
                    ></v-select>


                    <div style="font-weight: bold;text-align:center;min-width:10%;line-height: 2.2em; margin: 6px 10px;">～</div>

                    <v-select dense
                        append-icon="mdi-clock-time-four-outline"
                        menu-props="auto"
                        :items="second_end"
                        v-model="v.second_end"
                        outlined
                        placeholder="選択してください"
                        style="max-width: 40%;"
                    ></v-select>
            </v-col>
        </v-row>

    </v-container>
  </v-card>
</v-form>


        <template>
          <div class="text-center">
            <v-snackbar
              v-model="snackbar"
              timeout="1500"
              vertical
              top
              right
              outlined
            >
              <div v-html="snackbar_text"></div>
              <template v-slot:action="{  }">
                <img @click="snackbar = false" class="img" src="/img/x.svg" style="cursor:pointer;" />
              </template>
            </v-snackbar>
          </div>
        </template>

</div>
</template>

<script>
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import {mapGetters} from 'vuex';
import DialogStaffDelete from '@/components/DialogStaffDelete.vue';
/* eslint-disable */

export default {

    components:{
        DialogStaffDelete
    },

data() {  // datas
return {

        staff_id: null,   // 現在閲覧しているスタッフid
        snackbar: false,
        snackbar_text: '更新しました',
        records: [],

        first_start: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
        first_end: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
        second_start: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
        second_end: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],


            dialog: false,
            dialogDelete: false,

            title: 'スタッフ登録',
            is_new: true,
            valid: false,

            auths: ['管理者', 'チーフ', '一般'],
            jobs: ['歯科医', '歯科衛生士', '歯科助手', '事務'],
            pref: ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'],
            swatches: [
                    ['#AD1457', '#D81B60', '#D50000', '#E67C73'],
                    ['#F4511E', '#EF6C00', '#F09300', '#F6BF26'],
                    ['#E4C441', '#C0CA33', '#7CB342', '#33B679'],
                    ['#0B8043', '#009688', '#039BE5', '#4285F4'],
                    ['#3F51B5', '#7986CB', '#B39DDB', '#9E69AF'],
                    ['#8E24AA', '#795548', '#616161', '#A79B8E'],
                  ],

            show_password: false,
            menu_birthday: '',
            birthday: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu_hire_date: '',
            hire_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu_retirement_date: '',
            retirement_date: '',

            color: '',
            is_color_picker: false,

            data: {
                color: null,
                color_hex: null,
                staff_str_id: '',
                sei: '',
                mei: '',
                sei_kana: '',
                mei_kana: '',
                sex: null,       // 非選択を表す
                auth: null,
                birthday: '',
                password: '',
                post1: '',
                post2: '',
                prefecture: '',
                city: '',
                address: '',
                tel: '',
                phone: '',
                password: '',
                job: '',
                hire_date: '',
                retirement_date: '',
                jikyu: '',
                koutuhi: '',
                status: '',
                shuu_work: 1,
                eigyoubi: [],
            },

            rules_post1: [
            v => {
                if( v && v.length!==3 ){
                    return '3文字にしてください';
                }else{
                    return true;
                }
            }],
            rules_post2: [
                v => {
                    if( v && v.length!==4 ){
                        return '4文字にしてください';
                    }else{
                        return true;
                    }
            }],
}},  // datas


    watch: {
        birthday(val){
            this.data.birthday = val;
        },
        color(){
            console.log(this.color + '色');
            this.is_color_picker = false;
        },
        'data.post1': function(newVal){
              console.log('%c post1: '+newVal, mycolor.strong);
        },
        'data.post2': function(newVal){
              console.log('%c post2: '+newVal, mycolor.strong);
        },
    },  // watch


    methods: {
        onColorSelected() {
          console.log('onColorSelected');
          console.log(this.data.color.hex);

          if(this.data.color.hex==='#FF0000'){
              return false;
          }

          // カラーピッカーで色を選択後､カラーピッカーを閉じる
          this.data.color_hex = this.data.color.hex;
          this.is_color_picker = false;
        },


        // 下記のように最低限必要なリクエストを送れば、tokenを取得できる.
        // 呼び出し側で await getToken() で呼び出せば、responseがあるまで停止する
        async getToken(){
            console.log('getToken()');

            const formData = new FormData();
            formData.append('username', this.user.mail);
            formData.append('password', this.user.password);

            return axios.post('/token', formData)
                .then( response => {
                    return response.data;
                });
        },



        show_color_picker(){
            console.log(this.color);
            this.is_color_picker = true;

        },

      deleteItem (item) {
        console.log(item);
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        axios.get('/staff_delete/'+this.staff_id)
          .then((res) => {
            console.group();
            console.log('%c /staff_delete/'+this.staff_id, mycolor.api);
            console.log(res);
            console.groupEnd();
            this.$router.push('/stafflist').catch(()=>{});
          })
          .catch( () => {
            console.error();
          });
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
      },



        submit(){
            console.log('submit()');

            this.valid = this.$refs.form.validate();
            if(!this.valid){
                alert('入力エラーがあります.');
                return false;
            }

            console.log(this.data);

            // nullを許す項目をバックエンドで弾かれないようにする
            for( const k in this.data ){
                if(['jikyu', 'koutuhi', 'shuu_work', 'birthday', 'hire_date', 'retirement_date'].includes(k)){

                    console.log( '%c '+k, mycolor.strong );
                    if(this.data[k]==''){
                        this.data[k] = null;
                    }
                }
            }



            if(this.is_new){
                this.data.color = this.data.color_hex;
                axios.post('/staff_touroku', this.data)
                  .then((res) => {
                    console.log('%c /staff_touroku', mycolor.api);
                    console.log(res.data);
                    if(res.data.status!=='OK'){
                        alert("登録できませんでした\n\n"+res.data.msg);
                        return false;
                    }
                    this.$router.push('/stafflist').catch(()=>{});
                  })
                  .catch( (e) => {
                    alert("登録できませんでした\n\n");
                    console.error(e);
                    return false;
                  });
            }else{
                // 更新
                if(this.data.color===null){
                    this.data.color = '';
                }

                console.log(this.data);
                axios.post('/staff_update', this.data)
                  .then((res) => {
                    console.group();
                    console.log('%c /staff_update', mycolor.api);
                    console.log(res.data);
                    console.groupEnd();


                    this.snackbar = true;
                    this.update_vuex();

                  })
                  .catch( (e) => {
                      alert("更新に失敗しました");
                      console.error(e);
                      return false;
                  });
            }
        },  // submit()


        async update_vuex(){

                    // vuexを更新
                    let token = await this.getToken();  // ここのawaitがないと即座に下記が実行される.
                    console.log('待つよ getToken()');
                    console.log(token);

                    if(token.status==='NG'){
                        this.err_msg = token.msg;
                        return false;
                    }

                    if(token.status==='OK'){
                        // 認証が通ったら、localStorageに保存.
                        // token: と user: をシリアライズして格納する
                        delete token.status;
                        delete token.token_type;
                        delete token.msg;
                        localStorage.setItem( 'user', JSON.stringify(token) );

                        this.$store.dispatch( 'user', token.user );
                        this.$store.dispatch( 'notices', [] );
                    }
        },

        async fetchAddress() {
                console.log('fetchAddress');

                // 郵便番号のバリデーションチェック
                const reg = /^\d{7}$/
                let zipcode = this.data.post1+this.data.post2;
                if ( !reg.test(zipcode) ) return;

                const ZIPCODE_API_URL = 'https://api.zipaddress.net/?zipcode='+ zipcode;
                axios.get(ZIPCODE_API_URL, {
                    transformRequest: (data, headers) => {
                        delete headers.common['Authorization'];
                        return data;
                    }
                })
                .then((res) => {
                    console.group();
                    console.log('%c '+ZIPCODE_API_URL, mycolor.api);
                    console.log(res.data.data);
                    console.groupEnd();


                    // 存在しない郵便番号でapiを叩くと200以外のステータスが返ってくる
                    if (res.data.code !== 200) return;

                    this.data.prefecture = res.data.data.pref;
                    this.data.city = res.data.data.city;
                    this.data.address = res.data.data.town;

              })
              .catch((error) => {
                  console.error(error);
              });
        },

        validphone(name, v){
            // 電話番号の整形
            console.log('validphone');
            console.log(name);
            if( name==='tel' ){
                this.tel = v.replace(/-/mg, '');
            }else if( name==='phone' ){
                this.phone = v.replace(/-/mg, '');
            }
        }, // validphone


        get_eigyoubi(){
            // 新規スタッフは基本営業日を当てはめる

            console.log('get_eigyoubi');
            axios.get('/get_eigyoubi')
              .then((res) => {
                console.group();
                console.log('%c /get_eigyoubi', mycolor.api);
                console.log('基本営業日を取得しました.');
                console.log(res.data);
                console.groupEnd();

                // updated_at は不要なので削除する
                this.data.eigyoubi = res.data.map( (v) => {
                    delete v.updated_at;
                    return v;
                });

              })
              .catch( () => {
                console.error();
              });
        },




      // 初期化 todo:
      initialize () {

        console.log('initialize()');

        if( this.$route.name!=='staff_update' ){
            this.title = 'スタッフ登録';
            this.is_new = true;

            // 新規スタッフは各種設定の基本営業日を当てはめる
            this.get_eigyoubi();
            return false;


        }else{
            this.title = 'スタッフ編集';
            this.is_new = false;

            if( !this.is_admin && (this.staff_id*1 !== this.user.id) ){
                // 一般スタッフは閲覧禁止
                alert('閲覧できません');
                location.href = '/stafflist';
            }


            // スタッフdata取得
            axios.get('/get_staff_by_id/'+this.staff_id)
            .then( (ret) => {
                console.group();
                console.log('%c '+'/get_staff_by_id/'+this.staff_id, mycolor.api);
                console.log(ret.data);
                console.groupEnd();

                if(ret.data){
                    Object.assign(this.data, ret.data);
                    this.birthday = ret.data.birthday;

                }else{
                    alert('データが存在しません');
                    this.$router.push('/stafflist').catch(()=>{});
                }
            })
            .catch( (err) => {
                    console.log(err);
                    if(err && err.response && err.response.status===422){
                        console.log(err.response);
                        alert('データが存在しません');
                        this.$router.push('/stafflist').catch(()=>{});
                    }
            });
        }

      },  // initialize

    },  // methods



    created () {
        console.log('%c created: StaffView.vue', mycolor.created);
        this.staff_id = this.$route.params.id
        this.initialize();
    },

    computed: {
        ...mapGetters(['user', 'is_admin']),
    },  // computed

  }


</script>


<style scoped>
/*
カレンダーの土日に色をつける
*/

.v-date-picker-table.v-date-picker-table--date > table > tbody tr td:nth-child(1) .v-btn__content {
    color:red
}
.v-date-picker-table.v-date-picker-table--date > table > tbody tr td:nth-child(7) .v-btn__content {
    color:blue
}

.mycard{
  height: unset;
}
.myform .row{
  max-height: 100px;
}
.v-color-picker{
    max-width: none !important;
}
/deep/ .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
    height: 48px;
}
/deep/ .v-text-field.v-textarea:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
    height: unset !important;
}
/deep/ .v-input__append-inner{
    margin: 0 !important;
    margin: auto !important;
}
/deep/ .row + .row{
    margin-top: 0px;
}
/deep/ .mywhite .v-input__slot{
    background: #fff;
}
/deep/ .v-color-picker__color{
    width: 19px;
    border-radius: 30px;
}
/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .mypost{
    display: inline-block;
    width: 120px;
    vertical-align: middle;
}
/deep/ .mypost .v-text-field__details{
/*    display: none; */
}
/deep/ .mypost .error--text{
    position: absolute !important; 
    width: 200px !important;
}
/deep/ .gray .v-input__slot{
    background:#F0F0F0 !important;
}
/deep/ .v-text-field--outlined .v-label{
    color: #aaa;
}
/deep/ .v-snack--vertical .v-snack__wrapper{
    flex-direction: row !important;
    flex-wrap: wrap !important;
    justify-content: space-between !important;
    margin-top: 84px;
    min-width: unset;
    padding: 0 20px;
}
/deep/ .v-snack__content{
    padding: 0px !important;
    margin-right: 30px;
}
/deep/ .v-snack--vertical .v-snack__wrapper .v-snack__action{
    margin: 0 !important;
    align-self: unset !important;
}
/deep/ .v-snack:not(.v-snack--has-background) .v-snack__wrapper{
    border: none !important;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
</style>
